import { useState, useEffect } from "react";
import { query, collection, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../../util/firebase";
import BarLoader from "react-spinners/BarLoader";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";

function AdminPrizeDistributionsPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [distributions, setDistributions] = useState([]);
  const navigate = useNavigate();

  const fetchDistributions = async () => {
    try {
      setIsLoading(true);
      const q = query(
        collection(db, "audit_prize_distributions"),
        orderBy("distributedAt", "desc")
      );
      const docs = await getDocs(q);
      const data = docs.docs.map((d) => ({ id: d.id, ...d.data() }));
      setDistributions(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching prize distributions");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDistributions();
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="prizeDistributionsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        PRIZE DISTRIBUTIONS
      </h1>
      <div className="adminPageSection">
        {distributions.length === 0 ? (
          <p style={{ color: "#9aa3bf", textAlign: "center" }}>
            No distributions recorded yet.
          </p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {distributions.map((d) => (
              <div
                key={d.id}
                style={{ background: "#081026", padding: 12, borderRadius: 8 }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <strong>{d.league || "-"}</strong>
                    <div style={{ color: "#9aa3bf" }}>
                      Tournament: {d.tournamentSeason || "-"} ({d.tournamentUid}
                      )
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontWeight: 700 }}>
                      {d.totalDistributed || 0} tickets
                    </div>
                    <div style={{ color: "#9aa3bf" }}>
                      {new Date(
                        d.distributedAt?.toDate
                          ? d.distributedAt.toDate()
                          : d.distributedAt
                      ).toLocaleString()}
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 8 }}>
                  <details>
                    <summary style={{ cursor: "pointer" }}>
                      Winners ({d.winners?.length || 0})
                    </summary>
                    <div
                      style={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                      }}
                    >
                      {d.winners?.map((w, idx) => (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            {w.name || w.uid} - place {w.place}
                          </div>
                          <div style={{ fontWeight: 700 }}>
                            {w.amount} tickets
                          </div>
                        </div>
                      ))}
                    </div>
                  </details>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPrizeDistributionsPage;
